class Constants {
  readonly FOOTER_HEIGHT = 151;
  readonly APP_BAR_HEIGHT = 56;
  readonly IMAGE_BACKGROUND = "rgba(0, 86, 160, 0.08)";
}

export default new Constants();
